import Sidebar from "@/components/Sidebar";
import useAuth from "@/services/hooks/auth/useAuth";
import useAuthStore from "@/store/authStore";
import { Fragment } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "tvs-unified-lib";
import SidebarItems from "../sidebarItems";
import { MainContent } from "./styles";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore((state) => state);
  const { first_name, last_name } = user || {};

  const { logout } = useAuth();

  // const notifications = useQuery({
  //   queryKey: ["notifications"],
  //   queryFn: () => getData("events"),
  //   initialData: { data: { total: 0, unread: 0, events: [] } },
  // });

  // const action = useMutation({
  //   mutationFn: (id: number) => patchData(`events/${id}`),
  //   onSuccess: () => notifications.refetch(),
  // });

  return (
    <Fragment>
      <Sidebar
        items={SidebarItems(navigate)}
        onClickLogo={() => navigate("/")}
        title="Campaign"
        location={location}
        openSidebar={false}
        hasSupportChat={true}
        supportChatLoading={false}
        onSupportChatClick={() => {}}
      />
      <Navbar
        // notifications={notifications.data.data.events.map((e: any) => ({
        //   description: e.message,
        //   hasRead: e.read,
        //   time: e.rec_date,
        //   title: e.action_type,
        //   onClick: () => {
        //     if (e.action) {
        //       navigate(`/allocation/approval/${e.allocation_id}`);
        //     }
        //     action.mutate(e.id);
        //   },
        // }))}
        notifications={[]} // TODO: add notifications when backend is ready
        showNotificationIcon={false}
        showTaskIcon={false}
        showHistoryIcon={false}
        quickLinksComponent={<></>}
        userMenu={{
          fullname: `${first_name} ${last_name}`,
          links: [
            <a
              className="color-theme-red-500"
              onClick={() => {
                logout();
              }}
            >
              Log Out
            </a>,
          ],
        }}
      />
      <MainContent>
        <Outlet />
      </MainContent>
    </Fragment>
  );
};

export default DashboardLayout;
